import { cn } from "@/lib/utils";
import { TextChip } from "@/toggle-ui-kit/chip";

type ChipSize = "small" | "medium" | "large";

type NewChipColor = "indigo" | "pink" | "emerald" | "red";

export function NewChip({
  size,
  color,
  className,
}: {
  size?: ChipSize;
  color: NewChipColor;
  className?: string;
}) {
  const colorClass = {
    indigo: "bg-indigo-100 text-indigo-700",
    pink: "bg-pink-100 text-pink-700",
    emerald: "bg-emerald-100 text-emerald-700",
    // Figma red/100(#ffe2e2)·red/500(#fb2c36) — 프로젝트 v3 팔레트와 달라 정확 hex 사용
    red: "bg-[#ffe2e2] text-[#fb2c36]",
  };

  return (
    <TextChip size={size} className={cn(colorClass[color], className)}>
      New
    </TextChip>
  );
}
